import template from './service_settings.all.html'
import controller from './service_settings.all.controller'
import './service_settings.all.scss'

const serviceSettingsAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template,
    controller
}

export default serviceSettingsAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/all/service_settings.all.component.js